import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import axios from 'axios';

// axios.defaults.baseURL = 'http://beta.growthon.io:7000';
axios.defaults.baseURL = 'http://pinch.land:7000';
// axios.defaults.baseURL = 'http://127.0.0.1:7000';

// ReactDOM.render(<App />, document.getElementById('root'));
const app = document.getElementById('root');
ReactDOM.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>,
  app
);